import * as React from "react";
import {useTranslation} from "react-i18next";
import {MaxLengthInput} from "../MaxLengthInput";

interface IShippingPhoneNumberProps {
  onPhoneNumberChange: (phoneNo: string) => void;
  phoneNo?: string;
  isPhoneNumberValid: boolean;
}

/**
 * input field to set phone no. for carrier
 * @param props props containing shipping options to filter for 'isPhoneRequired', and Phone no. changed handler
 * @constructor
 */
const ShippingPhoneNo: React.FC<IShippingPhoneNumberProps> = (props: IShippingPhoneNumberProps) => {
  const {t} = useTranslation("checkout");
  const {isPhoneNumberValid, onPhoneNumberChange, phoneNo} = props;

  return (
    <React.Fragment>
      <div className="ShippingPhoneNo">
        <MaxLengthInput
          className={isPhoneNumberValid ? "" : "invalid"}
          defaultValue={phoneNo}
          hintText={t("Bitte geben Sie eine gültige Telefonnummer ein")}
          invalidHintCSSProps={{marginBottom: "0"}}
          lengthHintCSSProps={{marginBottom: "0"}}
          inputCSSProps={{borderColor: isPhoneNumberValid ? "green" : "red"}}
          name="phoneNo"
          onChangeCallback={(evt) => onPhoneNumberChange(evt.target.value)}
          placeholder={t("Telefonnummer für die Avisierung *")}
          type="tel"
        />
      </div>
      <p style={{fontSize: ".875rem"}}>{t("* Pflichtfeld")}</p>
    </React.Fragment>
  );
};

export default ShippingPhoneNo;
